import React, { useState } from 'react';
import {BASE_URL_RECURSOS} from '../../../constants';
import InComponentLoader from '../../Elements/Loader/componentloader';


const ThumbnailGrid = props => {
  // Receive {sizeX, sizeY, img_links, changePage}
  const [hover, setHover] = useState({});

  const toggleHover = (_inx, state) => {
    let _tmp = {};
    _tmp[_inx] = state;
    setHover(_tmp)
  }

  const el = [];
  props.img_links.map((img, inx) => { if(img.sArchivoTipo=="doc") return;
    el.push(
    <div key={"img-link-"+inx}
      style={{
        display: "inline-block",
        padding: "10px",
        overflow: "hidden",
        boxShadow: hover[inx]?"grey 0px 0px 20px":"",
      }}
      onMouseEnter={()=>toggleHover(inx, true)}
      onMouseLeave={()=>toggleHover(inx, false)}
      onClick={()=>props.selectImage(img)}
      >
        <h3>{img.name}</h3>
        <Thumbnail
          sizeY={props.sizeY}
          sizeX={props.sizeX}
          src={img.sArchivoRuta} />
    </div>
    )
  });

  return el
}
const Thumbnail = props => {
  // Receive {sizeX, sizeY, src}
  return (
    <img
      style={{
        width: props.sizeX,
        height: props.sizeY,
        backgroundImage: `url(${BASE_URL_RECURSOS+props.src})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }} />
  )
}

export default ThumbnailGrid;
